import axiosInstance from './apiIntercenpter';
import { CONTENT_API_PATHS, USER_API_PATHS, PAYMENT_API_PATHS } from "@/constants/apiPaths";
import apiIntercenpter from '@/services/apiIntercenpter';
import apiWithoutAuth from "@/services/apiWithoutAuth"
import { handleRedirectToUserWebPageLoginPage } from "@/utils/index"
import { userWebsitePaths } from "@/constants/userWebsitePaths"
import { allPaths } from '@/constants/urlPaths';
import { examType } from '@/pages/dashboard/constants';

const userLoginPath = process.env.REACT_APP_USER_PANEL_URL + userWebsitePaths.login
const myLearningPath = process.env.REACT_APP_USER_PANEL_URL + userWebsitePaths.myLearning

export const getHistoryVideosApiCall = async () => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const response = await apiIntercenpter.get(CONTENT_API_PATHS.HISTORY_VIDEO);
    if (response.data && response.data.status) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getHistoryVideosApiCall', error);
    return result;
    // throw error;
  }
};

export const getFavVideosApiCall = async () => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const response = await apiIntercenpter.get(CONTENT_API_PATHS.FAV_VIDEO);
    if (response.data && response.data.status) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getFavVideosApiCall', error);
    return result;
    // throw error;
  }
};


export const getSeriesBySubscriptionGroupApiCall = async (subscriptionGroupId: string) => {
  let result: any = {
    status: false,
    data: {},
  };
  try {
    const path = `${USER_API_PATHS.SERIES_BY_SUBSCRIPTION_GROUP}/${encodeURIComponent(subscriptionGroupId)}`;
    const response = await apiIntercenpter.get(path);
    if (response.data && response.data.status) {
      result.status = true;
      result = response.data;
    }
    return result;
  } catch (error) {
    console.error("Error fetching from getSeriesBySubscriptionGroupApiCall", error);
    return result;
  }
};

export const getDashboardDetailsApiCall = async () => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const response = await apiIntercenpter.get(CONTENT_API_PATHS.DASHBOARD);
    if (response.data && response.data.status) {
      if (response.data.data.length === 0) {
        // console.log("TODO handle : getDashboardDetailsApiCall ", myLearningPath)      
        handleRedirectToUserWebPageLoginPage("", false, myLearningPath)
      }

      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getDashboardDetailsApiCall', error);
    handleRedirectToUserWebPageLoginPage("Issue while getting dashboard details", true, userLoginPath)
    return result;
    // throw error;
  }
};

export const updateStudentNoticeReadStatusApiCall = async (noticeId: string) => {
  let result: any = {
    status: false,
    data: {},
  };
  try {
    const response = await apiIntercenpter.patch(CONTENT_API_PATHS.UPDATE_STUDENT_NOTICE_READ_STATUS, {
      noticeId,
      status: "read",
    });
    if (response.data && response.data.status) {
      result.status = true;
      result = response.data;
    }
    return result;
  } catch (error) {
    console.error("Error in updateStudentNoticeReadStatusApiCall", error);
    return result;
  }
};

export const getExamsApiCall = async () => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const response = await apiIntercenpter.get(CONTENT_API_PATHS.EXAM);
    if (response.data && response.data.status) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getExams', error);
    return result;
    // throw error;
  }
};


export const getTestsApiCall = async () => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const response = await apiIntercenpter.get(CONTENT_API_PATHS.TEST);
    if (response.data && response.data.status) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getTests', error);
    return result;
    // throw error;
  }
};


export const getTimelineApiCall = async (purchaseId: string) => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const url = CONTENT_API_PATHS.TIMELINE + "/" + purchaseId
    const response = await apiIntercenpter.get(url);
    if (response.data && response.data.status) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getTimelineApiCall', error);
    handleRedirectToUserWebPageLoginPage("Issue while getting timeline details", true, allPaths.dashboard)
    return result;
    // throw error;
  }
};


export const getUserProfileApiCall = async () => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const url = USER_API_PATHS.GET_PROILE
    const response = await apiIntercenpter.get(url);
    if (response.data && response.data.status) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getTests', error);
    handleRedirectToUserWebPageLoginPage("Issue while getting profile details", true, userLoginPath)
    return result;
    // throw error;
  }
};


export const getUgListApiCall = async () => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const url = CONTENT_API_PATHS.UG_DEGREES
    const response = await apiIntercenpter.get(url);
    if (response.data && response.data.status) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getTests', error);
    return result;
    // throw error;
  }
};


export const updateUserProfileApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_PROFILE;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error updating user profile:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};


export const updateUserBssFormApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_BSS_FORM;
    const response = await apiIntercenpter.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error updating bss form details:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};




export async function uploadImage(file: Blob, folderName: string, fileName: string) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folderName', folderName);
    formData.append('fileName', fileName);

    const response = await axiosInstance.post(USER_API_PATHS.UPLOAD_IMAGE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    });

    if (!response.data) {
      throw new Error('No data received from the server');
    }
    return response.data;
  } catch (error) {
    console.error('Failed to upload image:', error);
    throw error;
  }
}





export const claimCertificateApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.CLAIM_CERTIFICATE;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error updating user profile:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};




export const sendEmailOtpApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.SEND_EMAIL_OTP;
    const response = await apiIntercenpter.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error from sendEmailOtpApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};


export const verifyEmailOtpApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.VERIY_EMAIL_OTP;
    const response = await apiIntercenpter.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error from verifyEmailOtpApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};



export const markCertificateReceivedApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.MARK_CERTIFICATR_RECEIVER;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error updating user profile:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};


export const setSeriesWatchLaterDateApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.SET_SERIES_WATCH_LATER_DATE;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error updating user profile:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};


export const startSeriesApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.START_SERIES;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error updating user profile:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};



export const getInvoiceApiCallV1 = async (orderId: string) => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const url = USER_API_PATHS.GET_INVOICE + "/" + orderId
    const response = await apiIntercenpter.get(url);
    return response
    // if (response.data) {
    //   result = {
    //     status: true,
    //     data: response.data
    //   }
    // } else {
    //   console.log(response)
    // }
    // return result;
  } catch (error) {
    console.error('Error fetching from getInvoiceApiCall', error);
    return null;
    // throw error;
  }
};


export const getInvoiceApiCall = async (orderId: string) => {
  try {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const url = BASE_URL + USER_API_PATHS.GET_INVOICE + "/" + orderId

    // Get auth token for protected routes
    const AuthTokenService = (await import('./authToken')).default;
    const token = await AuthTokenService.ensureValidToken();
    // return null
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf',
      },
    });

    if (!response.ok) {
      return null
      // throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Return the response as a blob for PDF handling
    return await response.blob();
  } catch (error) {
    console.error("Error in getInvoicePDF:", error);
    throw error;
  }
};




export const getSeriesApiCall = async (
  seriesId: string,
  isWelcomeSeries: boolean = false,
  isSubscribedSeries: boolean = false
) => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    const url = CONTENT_API_PATHS.GET_SERIES + "/" + seriesId
    const response = await apiIntercenpter.get(url,{
      headers: {
        'x-is-welcome-series': isWelcomeSeries ? "true" : "false",
        'x-is-subscribed-series': isSubscribedSeries ? "true" : "false",
      }
    });
    if (response.data && response.data.status) {
      const payload = response.data
      const inner = payload.data

      // New shape: { records: Section[], notes?: Note[] }
      if (
        inner != null &&
        typeof inner === 'object' &&
        !Array.isArray(inner) &&
        Array.isArray((inner as { records?: unknown }).records)
      ) {
        const shaped = inner as { records: unknown[]; notes?: unknown[] }
        return {
          ...payload,
          data: shaped.records,
          seriesNotes: Array.isArray(shaped.notes) ? shaped.notes : [],
        }
      }

      // Legacy shape: data is Section[] directly
      if (Array.isArray(inner)) {
        return {
          ...payload,
          data: inner,
          seriesNotes: [],
        }
      }

      return payload
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getSeriesApiCall', error);
    handleRedirectToUserWebPageLoginPage("Issue while getting series details", true, allPaths.dashboard)
    return result;
    // throw error;
  }
};




export const getPublicVideoApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = CONTENT_API_PATHS.GET_PUBLIC_VIDEO;
    const response = await apiWithoutAuth.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error from getPublicVideoApiCall new:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};





export const toggleFavVideoApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.TOGGLE_FAVOURITE_VIDEO;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error updating user profile:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}




export const videoLikeDislikeApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_VIDEO_LIKE_DISLIKE;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error updating user profile:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}

export type MarkSeriesVideoWatchPayload = {
  seriesId: string;
  videoDocId: string;
  isWelcomeSeries: boolean;
  isPGCourseSeries: boolean;
  isSubscribedSeries: boolean;
  isWatched: boolean;
};

export const markSeriesVideoWatchApiCall = async (payload: MarkSeriesVideoWatchPayload) => {
  const result: { status: boolean; message?: string; [key: string]: any } = {
    status: false,
  };
  try {
    const url = USER_API_PATHS.MARK_SERIES_VIDEO_WATCH;
    const response = await apiIntercenpter.post(url, payload);
    const data = response.data;
    if (data?.status) {
      return { ...data, status: true };
    }
    return { status: false, message: data?.message };
  } catch (error: any) {
    console.error("Error in markSeriesVideoWatchApiCall:", error);
    const data = error.response?.data;
    return {
      status: false,
      message: typeof data?.message === "string" ? data.message : "Could not update watch status",
    };
  }
};



export const reportPrivateVideoQueryApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.REPORT_PRIVATE_VIDEO_QUERY;
    const response = await apiIntercenpter.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error from reportPrivateVideoQueryApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};




export const reportPublicVideoQueryApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.REPORT_PUBLIC_VIDEO_QUERY;
    const response = await apiWithoutAuth.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error from reportPublicVideoQueryApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};



export const getPrivateVideoCommentsApiCall = async (videoDocId: string) => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    let url: string = CONTENT_API_PATHS.GET_PRIVATE_VIDEO_COMMENTS
    url = url + "/" + videoDocId
    const response = await apiIntercenpter.get(url);
    if (response.data && (response.data.status || response.data.success)) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getVideoCommentsApiCall', error);
    return result;
    // throw error;
  }
};


export const getPublicVideoCommentsApiCall = async (videoDocId: string) => {
  let result: any = {
    status: false,
    data: {}
  }
  try {
    let url: string = CONTENT_API_PATHS.GET_PUBLIC_VIDEO_COMMENTS
    url = url + "/" + videoDocId
    const response = await apiWithoutAuth.get(url);
    if (response.data && (response.data.status || response.data.success)) {
      result.status = true
      result = response.data
    } else {
      console.log(response)
    }
    return result;
  } catch (error) {
    console.error('Error fetching from getVideoCommentsApiCall', error);
    return result;
    // throw error;
  }
};



export const addVideoCommentApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.ADD_VIDEO_COMMENT;
    const response = await apiIntercenpter.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error from addVideoCommentApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};


export const addReplyToCommentApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.ADD_COMMENT_REPLY;
    const response = await apiIntercenpter.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error from addVideoCommentApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};


export const addReplyToReplyApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.ADD_REPLY_TO_REPLY;
    const response = await apiIntercenpter.post(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in addReplyToReplyApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};


export const commentLikeDislikeApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_COMMENT_LIKE_OR_DISLIKE_COUNT;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in commentLikeDislikeApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}

export const replyLikeDislikeApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_REPLY_LIKE_OR_DISLIKE_COUNT;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in replyLikeDislikeApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}


export const updateVideoWatchCountApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_VIDEO_WATCH_COUNT;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in updateVideoWatchCountApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}

export const updateUserPurchaseContentApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_USER_PURCHASE_CONTENT;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in updateUserPurchaseContentApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}

export const updateWelcomeSeriesContentApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_WELCOME_SERIES_CONTENT;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in updateWelcomeSeriesContentApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}


export const createOrderApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = PAYMENT_API_PATHS.CREATE_ORDER;
    const response = await apiIntercenpter.post(url, payload);
    if (response.status && response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in createOrder:', error);
    // if (error.response && error.response.data) {
    //   return error.response.data
    // }
    return result
  }
};


export const createOrderForStripeApiCall = async (paymentIntent: any) => {
  let result = {
    status: false
  }
  try {
    const url = PAYMENT_API_PATHS.CREATE_STRIPE_ORDER_ID;
    const response = await apiIntercenpter.post(url, JSON.stringify(paymentIntent));
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in createOrder:', error);
    // if (error.response && error.response.data) {
    //   return error.response.data
    // }
    return result
  }
};



export const addTentativeOrderApiCall = async (orderDetails: any) => {
  let result = {
    status: false
  }
  try {
    const url = PAYMENT_API_PATHS.ADD_TENTATIVE_ORDER;
    const response = await apiIntercenpter.post(url, JSON.stringify(orderDetails));
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in addTentativeOrderAPI:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};




export const getOrderDetailsApiCall = async (orderId: string) => {
  let result = {
    status: false
  }
  try {
    let url: string = PAYMENT_API_PATHS.GET_ORDER_BY_ID
    url = url + "/" + orderId
    const response = await apiIntercenpter.get(url);
    if (response.data) {
      return response
    }
    return result
  } catch (error) {

    console.error("Error in getOrderDetailsApiCall:", error);
    return result;
    // throw error;
  }
}




export const createCCAvenuePaymentGatewayApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = PAYMENT_API_PATHS.CREATE_CCAVENUE_PAYMENT_GATEWAY;
    const response = await apiIntercenpter.post(url, JSON.stringify(payload));
    return response;
    // if (response.data) {
    //   return response.data
    // }
    // console.log("response in createCCAvenuePaymentGatewayApiCall:", response);
    // return result
  } catch (error: any) {
    console.error('Error in addTentativeOrderAPI:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
};




export const verifyCourseFreeExtensionApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    let url = USER_API_PATHS.VERIY_FREE_EXTENSION;
    if (payload.purchaseId && payload.extendedDurationPresetId && payload.durationId) {

      // sample api call url
      // {{BASE_URL}}/verify-free-extension?purchaseId=687b7890ed4ce3c1cf15a16e&extendedDurationPresetId=686e2421dfcd02c6e99c9c6f&durationId=686e2421dfcd02c6e99c9c70

      // url = url + "?purchaseId=" + payload.purchaseId + "&extendedDurationPresetId=" + payload.extendedDurationPresetId + "&durationId=" + payload.durationId

      const queryParams = new URLSearchParams({
        purchaseId: payload.purchaseId,
        extendedDurationPresetId: payload.extendedDurationPresetId,
        durationId: payload.durationId,
      });

      url += `?${queryParams.toString()}`;

      const response = await apiIntercenpter.get(url);
      if (response.data) {
        return response.data
      }
      return result
    } else {
      return result
    }
  } catch (error: any) {
    console.error('Error in verifyCourseFreeExtensionApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}



export const addCoursereeExtensionApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.ADD_COURSE_FREE_EXTENSION;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in addCoursereeExtensionApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}



export const updatePublicPrivateVideoViewCount = async (payload: any, isPublic: any) => {
  let result = {
    status: false
  }
  try {
    let url: any = USER_API_PATHS.UPDATE_PRIVATE_VIDEO_COUNT
    if (isPublic) {
      url = USER_API_PATHS.UPDATE_PUBLIC_VIDEO_COUNT;
    }
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in updatePublicPrivateVideoViewCount:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}




export const getCoursesOfNavBar = async () => {
  let result = {
    status: false
  }
  try {
    const url: string = USER_API_PATHS.GET_COURSES
    const response = await axiosInstance.get(url);
    if (response.status && response.data) {
      return response.data
    }
    return result
  } catch (error) {

    console.error("Error in getCoursesOfNavBar:", error);
    return result;
    // throw error;
  }
}



export const checkEligibilityForExamApiCall = async (purchaseId: any, currentExamType: any) => {
  let result = {
    status: false
  }
  try {
    let url: string = USER_API_PATHS.CHECK_ELIGIBILITY_FOR_EXAM + "/" + purchaseId
    if (currentExamType === examType.practice) {
      url = USER_API_PATHS.CHECK_ELIGIBILITY_FOR_TEST_EXAM + "/" + purchaseId
    }

    const response = await axiosInstance.get(url);
    if (response.status && response.data) {
      return response.data
    }
    return result
  } catch (error) {

    console.error("Error in checkEligibilityForExamApiCall:", error);
    return result;
    // throw error;
  }
}

export const getQuestionBankApiCall = async (courseId: any, currentExamType: any) => {
  let result = {
    status: false
  }
  try {
    let url: string = USER_API_PATHS.GET_QUESTION_BANK + "/" + courseId
    if (currentExamType === examType.practice) {
      url = USER_API_PATHS.GET_TEST_QUESTION_BANK + "/" + courseId
    }
    const response = await axiosInstance.get(url);
    if (response.status && response.data) {
      return response.data
    }
    return result
  } catch (error) {

    console.error("Error in getQuestionBankApiCall:", error);
    return result;
    // throw error;
  }
}



export const updateExamTimingsApiCall = async (payload: any, currentExamType: any) => {
  let result = {
    status: false
  }
  try {
    let url: any = USER_API_PATHS.UPDATE_EXAM_TIMINGS;
    if (currentExamType === examType.practice) {
      url = USER_API_PATHS.UPDATE_TEST_EXAM_TIMINGS;
    }
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in updateExamTimingsApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}



export const updateExamSubmitionApiCall = async (payload: any, currentExamType: any) => {
  let result = {
    status: false
  }
  try {
    let url: string = USER_API_PATHS.UPDATE_EXAM_SUBMITION;
    if (currentExamType === examType.practice) {
      url = USER_API_PATHS.UPDATE_TEST_EXAM_SUBMITION;
    }

    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in updateExamSubmitionApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}



export const updateExamStrikeApiCall = async (payload: any, currentExamType: any) => {
  let result = {
    status: false
  }
  try {
    let url: any = USER_API_PATHS.UPDATE_EXAM_STRIKE;
    if (currentExamType === examType.practice) {
      url = USER_API_PATHS.UPDATE_TEST_EXAM_STRIKE;
    }
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in updateExamStrikeApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}





export const addToResultApiCall = async (payload: any, currentExamType: any) => {
  let result = {
    status: false
  }
  try {
    let url: any = USER_API_PATHS.ADD_TO_RESULT;
    if (currentExamType === examType.practice) {
      url = USER_API_PATHS.ADD_TO_TEST_RESULT;
    }
    const response = await apiIntercenpter.post(url, payload);
    if (response.status && response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in createOrder:', error);
    // if (error.response && error.response.data) {
    //   return error.response.data
    // }
    return result
  }
};


export const getResultApiCall = async (purchaseId: any, currentExamType: any) => {
  let result = {
    status: false
  }
  try {
    let url: string = USER_API_PATHS.GET_RESULT + "/" + purchaseId
    if (currentExamType === examType.practice) {
      url = USER_API_PATHS.GET_TEST_RESULT + "/" + purchaseId
    }
    const response = await axiosInstance.get(url);
    if (response.status && response.data) {
      return response.data
    }
    return result
  } catch (error) {

    console.error("Error in getQuestionBankApiCall:", error);
    return result;
    // throw error;
  }
}


export const updateExamStatusApiCall = async (payload: any) => {
  let result = {
    status: false
  }
  try {
    const url = USER_API_PATHS.UPDATE_EXAM_STATUS;
    const response = await apiIntercenpter.patch(url, payload);
    if (response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in updateExamStatusApiCall:', error);
    if (error.response && error.response.data) {
      return error.response.data
    }
    return result
  }
}


export const reattemptExamApiCall = async (payload: any, currentExamType: any) => {
  let result = {
    status: false
  }
  try {
    let url: any = USER_API_PATHS.REATTEMPT_EXAM;
    if (currentExamType === examType.practice) {
      url = USER_API_PATHS.REATTEMPT_TEST_EXAM
    }

    const response = await apiIntercenpter.post(url, payload);
    if (response.status && response.data) {
      return response.data
    }
    return result
  } catch (error: any) {
    console.error('Error in xxpxApiCall:', error);
    // if (error.response && error.response.data) {
    //   return error.response.data
    // }
    return result
  }
};
